import React, { useState, useEffect, useCallback } from 'react';

interface DynamicFontLoaderResult {
	addFont: (fontFamily: string) => void;
}

interface DynamicFontLoaderProps {
	// No props needed for this component
}

const DynamicFontLoader = (): DynamicFontLoaderResult => {
	const [fontFamilies, setFontFamilies] = useState<string[]>([]);

	const addFont = useCallback(
		(fontFamily: string) => {
			if (fontFamily && !fontFamilies.includes(fontFamily)) {
				setFontFamilies((prevFonts) => [...prevFonts, fontFamily]);
			}
		},
		[fontFamilies]
	);

	useEffect(() => {
		if (!fontFamilies || fontFamilies.length === 0) return;

		fontFamilies.forEach((fontFamily) => {
			const existingLink = document.querySelector(`link[data-font="${fontFamily}"]`);
			if (existingLink) return;

			const formattedFontFamily = encodeURIComponent(fontFamily);
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = `https://fonts.googleapis.com/css2?family=${formattedFontFamily}:wght@300;400;700&display=swap`;
			link.dataset.font = fontFamily;
			document.head.appendChild(link);
		});

		return () => {
			fontFamilies.forEach((fontFamily) => {
				const linkToRemove = document.querySelector(`link[data-font="${fontFamily}"]`);
				if (linkToRemove) {
					document.head.removeChild(linkToRemove);
				}
			});
		};
	}, [fontFamilies]);

	const result: DynamicFontLoaderResult = { addFont };

	return { addFont };
};

export default DynamicFontLoader;
